<template>
  <div class="modal">
    <div v-if="!isMobile" class="modal-dialog" v-click-outside="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            History of {{ selectedTriggerWithAlertInfo.trigger }} for
            {{ selectedTriggerWithAlertInfo.alertName }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <vxe-table
            empty-text="No data"
            border="outer"
            :row-config="rowConfig"
            :data="tableData"
          >
            <vxe-column
              field="timestamp"
              title="Date"
              sortable
              sort-by="timestamp"
              :formatter="formatDate"
            ></vxe-column>
            <vxe-column
              field="reason"
              title="Incident"
              sortable
              sort-by="reason"
              :formatter="formatIncident"
            ></vxe-column>
          </vxe-table>
        </div>
      </div>
    </div>

    <div
      v-if="isMobile"
      id="mobile"
      class="modal-dialog"
      v-click-outside="closeModal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            History of {{ selectedTriggerWithAlertInfo.trigger }} <br />
            for {{ selectedTriggerWithAlertInfo.alertName }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <ul v-if="tableData.length">
            <li v-for="(item, index) in tableData" :key="index">
              <div class="date">
                <span>Date</span>
                <span>{{ item.timestamp | dateFormatter }}</span>
              </div>
              <div class="incident">
                <span>Incident</span>
                <span>{{ formatIncidentOnMobile(item.reason) }}</span>
              </div>
            </li>
          </ul>
          <p v-else class="no-data">No data</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapState } from 'vuex';
import * as vClickOutside from 'v-click-outside';

export default {
  name: 'TriggerHistory',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      rowConfig: { isHover: false },
      tableData: []
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapState('alertsSuspiciousTrafficStore', [
      'selectedTriggerWithAlertInfo'
    ]),
    ...mapGetters('alertsSuspiciousTrafficStore', [
      'selectedTriggerOfAlertDetails'
    ])
  },
  methods: {
    formatDate({ cellValue }) {
      const date = cellValue
        ? dayjs(cellValue).toString()
          ? dayjs(cellValue)
              .toString()
              .substring(4, 16)
          : ''
        : '-';
      return date;
    },
    formatIncident({ cellValue }) {
      if (cellValue.indexOf('First hit') === 0) return 'First hit';

      return cellValue;
    },
    formatIncidentOnMobile(val) {
      if (val.indexOf('First hit') === 0) return 'First hit';

      return val;
    },
    closeModal() {
      this.$emit('closeModal');
    }
  },
  mounted() {
    this.tableData = this.selectedTriggerOfAlertDetails;

    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        this.closeModal();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 60%;
  max-width: 40rem;
}

.modal-body {
  padding: 1rem 2rem;
  height: 60vh;
  overflow-y: scroll;
}

#mobile {
  &.modal-dialog {
    width: 90%;
  }

  .modal-body {
    padding: 0;
    height: calc(90vh - 6rem);
    overflow-y: scroll;

    .no-data {
      padding: 1rem;
    }
  }

  ul {
    list-style: none;
  }

  li {
    border-bottom: 1px solid #ddd;
    padding: 1rem 1.5rem;
  }

  .date,
  .incident {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .date {
    margin-bottom: 1rem;
  }

  .date span:nth-child(1),
  .incident span:nth-child(1) {
    color: $icon-grey;
    font-weight: 600;
  }
}
</style>
